module.exports = __webpack_public_path__ + "img/1-3.58cedaeb.png";